import { getSubStepValues } from '#models/general/steps';
import { getCheckboxesRows } from '#models/general/fields/checkboxPercentage';

import { NEW_PRODUCT_SUBSTEPS_IDS } from './constants';

export const BLENDED_BY_OPTIONS = {
  ALEX_BRUCE: 'alexBruce',
  CONNAL_MACKENZIE: 'connalMackenzie',
  GRAEME_MACKAY: 'graemeMackay',
  ANTONIA_BRUCE: 'antoniaBruce',
  JENNY_KARLSSON: 'jennyKarlsson',
  CARL_CRAFTS: 'carlCrafts'
};

export const getBlendedByFields = ({ values, errors }) => {
  const getBlendedByValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.BLENDED_BY, values, errors);
  return getCheckboxesRows(Object.values(BLENDED_BY_OPTIONS), getBlendedByValues, values);
};
